import React from 'react';
import Icon from "./Icon";

class Toast extends React.Component {
    constructor(props) {
        super(props);
        this.typeList = ["info", "warning", "danger", "success"];
        this.state = {
            toggle : true
        }
    }
    render(){
        let {type = "info",  closing = true, content = ""} = this.props;
        if(!this.typeList.includes(type)){type = "info";}
        return this.state.toggle ? (
            <div className="toast">
                <div className={`content ${type}`}>
                    <div className="text">
                        {content}
                    </div>
                    {closing ? <div className={"close"}><Icon type={"close"} callback={() => this.setState({toggle : false})} /></div> : null}
                </div>
            </div>
        ) : null
    }
}

export default Toast;